<template>
  <empty-cart
    v-if="isCartEmpty"
    :title="'SHOPPING BAG'"
    :item-name="'bag'"
    :where-to-go-button="'wishlist'"
    :to="{ name: 'Wishlist' }"
  ></empty-cart>

  <loading-page v-else-if="isLoading"></loading-page>

  <div v-else class="cart">
    <h1 class="cart-wishlist-title">Shopping Bag</h1>
    <div class="container">
      <div class="cart-container">
        <p class="items-para">Items:</p>
        <transition-group name="fade" tag="ul" class="products">
          <li
            v-for="product in formattedCart"
            :key="product._id + product.size"
            class="product-info"
          >
            <div class="product-cart-wishlist-container">
              <img
                v-if="product.productId && product.productId.image"
                :src="product.productId.image"
                :alt="product.productId.name"
                class="product-image"
              />
              <div class="product-cart-wishlist-info">
                <div class="title-delete-button">
                  <p v-if="product.productId" class="product-name">
                    <strong>{{ product.productId.name }}</strong>
                  </p>
                  <button
                    class="remove-item-button"
                    @click="removeFromCart(product)"
                  >
                    <img src="/images/trash.svg" alt="trach button" />
                    Delete
                  </button>
                </div>
                <p v-if="product.productId" class="product-color">
                  Color: {{ getColorName(product.productId.color) }}
                </p>
                <p v-if="product.productId" class="product-size">
                  Size: {{ product.size }}
                </p>
                <div class="add-item-price-info">
                  <div class="buttons">
                    <minus-button
                      :disabled="product.quantity === 1"
                      @click="decrement(product)"
                    ></minus-button>
                    <span class="amount">{{ product.quantity }}</span>
                    <plus-button @click="increment(product)"></plus-button>
                  </div>
                  <p v-if="product.productId" class="product-price">
                    Price: {{ product.totalPrice }}$
                  </p>
                </div>
              </div>
            </div>
          </li>
        </transition-group>
      </div>
      <div class="payment-container">
        <p class="items-para">Information about your order:</p>
        <div class="payment">
          <div class="payment-top">
            <div v-if="!isLoggedIn" class="guest-user">
              <p class="log-in">Log in</p>
              <p class="log-in-info">
                Go to your account to get a discount card and to track parcels.
              </p>
              <div class="button-container">
                <router-link :to="{ name: 'Registration' }">
                  <button class="login-button">Log in</button>
                </router-link>
              </div>
            </div>
            <div v-else class="auth-user">
              <p class="bonus">0.00$ bonus</p>
              <router-link to="/404" class="learn-more">Learn more</router-link>
              <router-link :to="{ name: 'Registration' }">
                <button class="profile-button" style="width: 100%">
                  Go to profile
                </button>
              </router-link>
            </div>
          </div>
          <div class="price-info-pop-up">
            <hr />
            <div class="promocode">
              <p class="promocode-text">Promocode</p>
              <p class="promocode-text-value">-</p>
            </div>
            <div class="delivery">
              <p class="delivery-text">Delivery</p>
              <p class="delivery-text-value">20.00$</p>
            </div>
          </div>
          <hr />
          <div class="total-price">
            <p class="total-text">Total:</p>
            <p class="total-text-value">{{ totalPrice }}$</p>
          </div>
          <div class="button-container">
            <router-link
              :to="{ name: 'Ordering' }"
              style="width: 80%; display: block"
            >
              <button class="checkout-button" style="width: 100%">
                Checkout
              </button>
            </router-link>
          </div>
          <p class="accept-text">We accept</p>
          <div class="payment-methods">
            <img src="/images/applePay.svg" alt="" />
            <img src="/images/googlePay.svg" alt="" />
            <img src="/images/visa.svg" alt="" />
            <img src="/images/mastercard.svg" alt="" />
            <img src="/images/paypal.svg" alt="" />
            <img src="/images/maestro.svg" alt="" />
            <img src="/images/western.svg" alt="" />
          </div>
        </div>
        <el-collapse class="custom-collapse">
          <el-collapse-item title="More about shipping and returns" name="2">
            Your order will be carefully packed and shipped within 1–3 business
            days. Returns are accepted with no hassle — just contact us and
            we’ll guide you through the process.
          </el-collapse-item>
          <el-collapse-item title="Privacy Policy" name="1">
            Your privacy is important to us. We collect and process personal
            information only as necessary to provide our services, and we ensure
            that your data is kept secure and confidential. We do not share your
            personal information with third parties without your consent, except
            as required by law. By using our services, you agree to the
            collection and use of your information in accordance with this
            Privacy Policy.
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import EmptyCart from "./EmptyCart.vue";
import { mapGetters } from "vuex";
import namer from "color-namer";
import MinusButton from "./base/MinusButton.vue";
import PlusButton from "./base/PlusButton.vue";

export default {
  components: { EmptyCart, MinusButton, PlusButton },

  data() {
    return {
      isLoading: true,
    };
  },

  computed: {
    ...mapGetters("cart", ["getCart"]),

    userId() {
      const userData = this.$store.getters.userData;
      return userData && userData.id ? userData.id : "guest";
    },

    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },

    totalPrice() {
      return this.formattedCart.reduce(
        (sum, product) => sum + product.totalPrice,
        20
      );
    },

    formattedCart() {
      if (this.userId === "guest") {
        return this.getCart.map((product) => {
          const price = product.productId?.price || 0;
          const quantity = Number(product.quantity); // убедимся, что это число
          return {
            _id: product._id,
            productId: product.productId,
            size: product.size,
            quantity,
            totalPrice: price * quantity,
          };
        });
      } else {
        return (this.getCart.products || []).map((product) => {
          const price = product.productId?.price || 0;
          const quantity = product.quantity || 1;
          return {
            ...product,
            totalPrice: price * quantity,
          };
        });
      }
    },

    isCartEmpty() {
      if (this.userId === "guest") {
        return this.getCart.length === 0;
      } else {
        return !this.getCart.products || this.getCart.products.length === 0;
      }
    },
  },

  methods: {
    async increment(product) {
      if (!product || !product.productId) return;

      const productId = product.productId._id || product.productId.id;

      if (this.userId === "guest") {
        const guestCart = JSON.parse(localStorage.getItem("guestCart")) || [];
        const productIndex = guestCart.findIndex(
          (item) => item.productId === productId && item.size === product.size
        );
        if (productIndex !== -1) {
          guestCart[productIndex].quantity += 1;
        } else {
          guestCart.push({
            productId: product.productId,
            size: product.size,
            quantity: 1,
          });
        }

        localStorage.setItem("guestCart", JSON.stringify(guestCart));
        this.$store.dispatch("cart/fetchCart", this.userId);
      } else {
        await fetch(`${process.env.VUE_APP_URL}/cart`, {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            userId: this.userId,
            productId: productId,
            size: product.size,
            operation: "increment",
          }),
        });

        await this.$store.dispatch("cart/fetchCart", this.userId);
      }
    },

    async decrement(product) {
      if (!product || !product.productId) return;

      const productId = product.productId._id || product.productId.id;

      if (this.userId === "guest") {
        const guestCart = JSON.parse(localStorage.getItem("guestCart")) || [];
        const productIndex = guestCart.findIndex(
          (item) => item.productId === productId && item.size === product.size
        );

        if (productIndex !== -1 && guestCart[productIndex].quantity > 1) {
          guestCart[productIndex].quantity -= 1;
        }

        localStorage.setItem("guestCart", JSON.stringify(guestCart));
        this.$store.dispatch("cart/fetchCart", this.userId);
      } else {
        await fetch(`${process.env.VUE_APP_URL}/cart`, {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            userId: this.userId,
            productId: productId,
            size: product.size,
            operation: "decrement",
          }),
        });

        await this.$store.dispatch("cart/fetchCart", this.userId);
      }
    },

    getColorName(hex) {
      if (!hex) return "unknown";
      return namer(hex).html[0].name;
    },

    removeFromCart(product) {
      const userData = this.$store.getters.userData;
      const userId = userData && userData.id ? userData.id : "guest";

      const productId = product.productId?._id || product.productId?.id;
      const size = product.size;

      console.log("userId:", userId, "productId:", productId, "size:", size);

      this.$store.dispatch("cart/removeFromCart", { userId, productId, size });
    },
  },

  async mounted() {
    this.$store.dispatch("checkLoggedIn");
    const userData = this.$store.getters.userData;
    const userId = userData && userData.id ? userData.id : "guest";
    await this.$store.dispatch("cart/fetchCart", userId).then(() => {
      this.isLoading = false;
    });
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateX(-50%);
}

.remove-item-button {
  background: transparent;
  color: #000;
  font-size: 2.2rem;
  font-weight: 400;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.product-info {
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.13);
  background: #e2e2e2;
  min-width: 70rem;
  padding: 20px;
  flex-shrink: 1;
}

.cart-wishlist-title {
  color: #000;
  font-family: "Glusp";
  font-size: clamp(2.6rem, 3vw, 3.6rem);
  font-weight: 700;
  text-align: center;
  margin-bottom: 45px;
}

.container {
  display: flex;
  justify-content: space-between;
}

.products {
  display: flex;
  flex-direction: column;
  gap: 25px;
  list-style-type: none;
}

.product-cart-wishlist-container {
  display: flex;
  gap: 30px;
}

.product-cart-wishlist-info {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 18px;
  flex-shrink: 1;
}

.title-delete-button,
.add-item-price-info {
  display: flex;
  justify-content: space-between;
}

.add-item-price-info {
  align-items: flex-end;
}

.cart {
  padding: 40px;
}

.product-image {
  height: 18.5rem;
}

.product-name {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2.1rem;
  font-weight: 500;
}

.product-color {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2.1rem;
  font-weight: 300;
}

.buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
}

.amount {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.5rem;
  font-weight: 500;
}

.product-price {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2.4rem;
  font-weight: 500;
}

.product-size {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2.1rem;
  font-weight: 300;
}

.payment {
  max-width: 60rem;
  min-width: 30rem;
  background: #fff;
  margin-bottom: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 40px 20px 20px 20px;
}

.breadcrumbs-container {
  padding: 40px 40px 0px 40px;
}

::v-deep(.el-icon) {
  width: 5rem;
}

::v-deep(.breadcrumb__inner.is-link):hover {
  color: #000 !important;
}

.el-breadcrumb {
  display: flex;
  align-items: center;
}

::v-deep(.el-breadcrumb__inner) {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.8rem;
  font-weight: 500;
}

.custom-collapse {
  max-width: 63rem;
}

.custom-collapse ::v-deep(.el-collapse-item__header) {
  padding: 30px;
  color: #000;
  font-family: "Mabry Pro";
  font-size: clamp(1.3rem, 3vw, 2.4rem);
  font-weight: 500;
  border-radius: 8px 8px 0 0;
}

.custom-collapse ::v-deep(.el-collapse-item__content) {
  padding: 5px 30px 10px 30px;
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.6rem;
  font-weight: 300;
}

.custom-collapse ::v-deep(.el-collapse-item__wrap) {
  border-radius: 0 0 8px 8px;
}

.custom-collapse ::v-deep(.el-collapse-item:not(:last-child)) {
  margin-bottom: 15px;
}

.promocode,
.delivery {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.delivery {
  margin-bottom: 12px;
}

.promocode-text,
.delivery-text {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2.1rem;
  font-weight: 300;
}

.promocode-text-value {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 5rem;
  font-weight: 300;
}

.delivery-text-value {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2.1rem;
  font-weight: 500;
}

.total-price {
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
}

.total-text {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2.9rem;
  font-weight: 300;
}

.total-text-value {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2.9rem;
  font-weight: 500;
}

.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 25px;
  width: 100%;
}

.auth-user {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.checkout-button,
.login-button,
.profile-button {
  color: #fff;
  font-family: "Mabry Pro";
  font-size: 2rem;
  font-weight: 500;
  border-radius: 4px;
  background: #000;
  padding: 8px 18px;
  text-align: center;
  height: 60px;
  width: 80%;
}

.checkout-button {
  width: 100%;
}

.login-button {
  margin-bottom: 80px;
  min-width: 20rem;
}

.profile-button {
  width: 20rem;
  height: 6rem;
  margin-bottom: 40px;
}

.accept-text {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 1.4rem;
  font-weight: 300;
  margin-bottom: 8px;
}

.bonus {
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2.2rem;
  font-weight: 300;
}

.payment-methods {
  display: flex;
  gap: 25px;
  flex-wrap: wrap;
}

.guest-user {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 15px;
}

.learn-more {
  color: #0085ff;
  font-family: "Mabry Pro";
  font-size: 1.7rem;
  font-weight: 300;
  text-decoration-line: underline;
}

.log-in,
.log-in-info {
  text-align: center;
  color: #000;
  font-family: "Mabry Pro";
  font-size: 2.2rem;
}

.log-in {
  font-weight: 500;
}

.log-in-info {
  font-weight: 300;
  max-width: 36rem;
}



@media screen and (min-width: 240px) and (max-width: 480px) {
  .container {
    flex-direction: column;
  }
  .product-cart-wishlist-container {
    flex-direction: column;
    max-width: 25rem;
  }
  .product-info {
    width: 30rem;
    min-width: 0; 
    max-width: 100%; 
  }
  .add-item-price-info {
    flex-direction: column;
    align-items: start;
    gap: 15px;
  }
  .products {
    align-items: center;
  } 
  .cart {
    padding: 30px 10px;
  }
  .items-para {
    margin-top: 15px;
  }
}

@media screen and (min-width: 481px) and (max-width: 768px) {
  .container {
    flex-direction: column;
  }
  .product-cart-wishlist-container {
    flex-direction: column;
    max-width: 25rem;
  }
  .product-cart-wishlist-container {
    flex-direction: column;
    max-width: 25rem;
  }
  .product-info {
    width: 30rem;
    min-width: 0; 
    max-width: 100%; 
  }
  .add-item-price-info {
    flex-direction: column;
    align-items: start;
    gap: 15px;
  }
  .products {
    align-items: center;
  } 
  .cart {
    padding: 30px 10px;
  }
  .items-para {
    margin-top: 15px;
  }
}

@media screen and (min-width: 769px) and (max-width: 1024px) {
  .container {
    flex-direction: column;
  }
}

@media screen and (min-width: 1025px) and (max-width: 1200px) {
  .container {
    flex-direction: column;
  }
}

@media screen and (min-width: 1200px) and (max-width: 1600px) {
  .container {
    flex-direction: column;
  }
}
</style>
